import styled from '@emotion/styled';
import { Divider } from 'src/components/AzarOnly/Match/Matching/styles';
import { BOTTOM_TAB_BAR_HEIGHT } from 'src/components/BottomTabBar';
import { SkeletonBar, SkeletonCircle, SkeletonRect } from 'src/components/Skeleton';
const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  ${({
  theme
}) => theme.screenSize.tablet} {
    margin-bottom: ${BOTTOM_TAB_BAR_HEIGHT};
  }
`;
const ItemContainer = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;

  ${({
  theme
}) => theme.screenSize.desktop} {
    padding: 12px 24px;
  }
`;
const FollowLinkContainer = styled(ItemContainer)`
  padding: 12px 24px;

  ${({
  theme
}) => theme.screenSize.mobile} {
    padding: 12px 16px;
  }

  ::after {
    content: '';
    position: absolute;
    bottom: calc(-1 * (4px + 1px));
    inset-inline-start: 0;
    width: 100%;
    height: 1px;
    background-color: ${({
  theme
}) => theme.color.surface2};
  }
`;
const Content = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const DividerWrapper = styled.div`
  padding: 4px 24px;
`;
const TimeSkeleton = styled(SkeletonBar)`
  margin-inline-start: auto;
`;
const FollowLinkItemSkeleton = () => <FollowLinkContainer data-sentry-element="FollowLinkContainer" data-sentry-component="FollowLinkItemSkeleton" data-sentry-source-file="Skeleton.tsx">
    <SkeletonCircle size={56} data-sentry-element="SkeletonCircle" data-sentry-source-file="Skeleton.tsx" />
    <Content data-sentry-element="Content" data-sentry-source-file="Skeleton.tsx">
      <HeaderRow data-sentry-element="HeaderRow" data-sentry-source-file="Skeleton.tsx">
        <SkeletonBar width='100px' height={20} data-sentry-element="SkeletonBar" data-sentry-source-file="Skeleton.tsx" />
      </HeaderRow>
      <HeaderRow data-sentry-element="HeaderRow" data-sentry-source-file="Skeleton.tsx">
        <SkeletonBar width='150px' height={17} data-sentry-element="SkeletonBar" data-sentry-source-file="Skeleton.tsx" />
      </HeaderRow>
    </Content>
    <SkeletonRect width='50px' height='27px' radius={20} data-sentry-element="SkeletonRect" data-sentry-source-file="Skeleton.tsx" />
  </FollowLinkContainer>;
const RoomItemSkeleton = () => <ItemContainer data-sentry-element="ItemContainer" data-sentry-component="RoomItemSkeleton" data-sentry-source-file="Skeleton.tsx">
    <SkeletonCircle size={56} data-sentry-element="SkeletonCircle" data-sentry-source-file="Skeleton.tsx" />
    <Content data-sentry-element="Content" data-sentry-source-file="Skeleton.tsx">
      <HeaderRow data-sentry-element="HeaderRow" data-sentry-source-file="Skeleton.tsx">
        <SkeletonBar width='80px' height={20} data-sentry-element="SkeletonBar" data-sentry-source-file="Skeleton.tsx" />
        <TimeSkeleton width='40px' height={12} data-sentry-element="TimeSkeleton" data-sentry-source-file="Skeleton.tsx" />
      </HeaderRow>
      <HeaderRow data-sentry-element="HeaderRow" data-sentry-source-file="Skeleton.tsx">
        <SkeletonBar width='180px' height={17} data-sentry-element="SkeletonBar" data-sentry-source-file="Skeleton.tsx" />
      </HeaderRow>
    </Content>
  </ItemContainer>;
const RoomListSkeleton = () => <List data-sentry-element="List" data-sentry-component="RoomListSkeleton" data-sentry-source-file="Skeleton.tsx">
    <FollowLinkItemSkeleton data-sentry-element="FollowLinkItemSkeleton" data-sentry-source-file="Skeleton.tsx" />
    <DividerWrapper data-sentry-element="DividerWrapper" data-sentry-source-file="Skeleton.tsx">
      <Divider data-sentry-element="Divider" data-sentry-source-file="Skeleton.tsx" />
    </DividerWrapper>
    {Array.from({
    length: 5
  }, (_, i) => <RoomItemSkeleton key={i} />)}
  </List>;
export default RoomListSkeleton;